import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";
import { ROUTE_PATH } from "../constants/route-path";
import { cloneDeep } from 'lodash';
import { ProcessLoadingService } from "../services/loading.service";
import { LoginFlowService } from "../services/login-flow.service";

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private pageLoadingService: ProcessLoadingService,
        private loginFlowService: LoginFlowService
    ) { }

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        const queryAccessToken = route?.queryParams['accessToken'] || null;
        const queryRefreshToken = route?.queryParams['refreshToken'] || null;

        const isLoggedIn = this.authenticationService.isLoggedIn();

        if (queryAccessToken && queryRefreshToken) {
            return await this.handleTokenLogin(queryAccessToken, queryRefreshToken);
        }

        if (!isLoggedIn) {
            this.authenticationService.setprevUr(window.location.pathname?.replace('/', ''));
        }
        if (isLoggedIn) {
            const validPermission = this.checkMenuPermission(route.routeConfig?.path);
            if (validPermission) {
                return true;
            } else {
                window.location.href = ROUTE_PATH.PAGE_NOT_FOUND;
                return false;
            }
        }

        this.router.navigate([ROUTE_PATH.LOGIN]);
        return false;
    }

    async canActivateChild(route: ActivatedRouteSnapshot): Promise<boolean> {
        return await this.canActivate(route);
    }

    checkMenuPermission(currentUrl: string | undefined): boolean {
        // const currentRole = this.authenticationService.currentRole();
        // const data: any = cloneDeep(MENU);
        // if (!currentRole) return false;

        // for (let i = 0; i < data.length; i++) {
        //     const groupMenu = cloneDeep(data[i]);
        //     for (let j = 0; j < groupMenu.length; j++) {
        //         const menu = groupMenu[j];
        //         if (String(currentUrl).includes(menu.path) &&
        //             menu.permissions &&
        //             menu.permissions.length > 0 &&
        //             ![...menu.permissions].includes(String(currentRole))) {
        //             return false;
        //         }
        //     }
        // }

        return true;
    }

    async handleTokenLogin(queryAccessToken?: string, queryRefreshToken?: string): Promise<boolean> {
        if (!queryAccessToken || !queryRefreshToken) return false;

        const loginAndHandle = async () => {
            const userInfo = await this.authenticationService.loginByToken(queryAccessToken, queryRefreshToken);
            if (!userInfo) return false;
            return this.loginFlowService.handleLoginSuccess(userInfo);
        };

        if (!this.authenticationService.isLoggedIn()) {
            return await loginAndHandle();
        }

        const currentUser = this.authenticationService.currentUserValue;
        const userId = currentUser?.userId;

        const isCurrentUser = this.authenticationService.isCurrentUser(queryAccessToken, userId);
        if (isCurrentUser) {
            this.router.navigate(['/']);
            return true;
        }

        // await this.authenticationService.logout(false);
        return await loginAndHandle();
    }
}
